import React from 'react'
import { Card, CardMedia, CardActionArea, Chip } from '@material-ui/core'
import { useStyles } from './classes'
import styles from './TrendingCard.module.css'
import { useHistory } from "react-router-dom";

const TrendingCard = ({ trending }) => {
  const classes = useStyles()
  const history = useHistory();

  
  const redirect =()=>{
    history.push(`/restaurant/${trending.restaurantId._id}/search`)
  }

  return (
    <Card
      className={classes.root}
      style={{ borderRadius: '50px', }}
      onClick={()=>redirect()}
    >
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={trending.image}
          title='Dish Image'
         
        />

        <img
          src={trending.restaurantId.logo}
          alt='restaurant-logo'
          className={styles.Img}
        />

        <Chip
          className={styles.Chip}
          label={trending.restaurantId.name}
          style={{ borderRadius: '0px 10px 10px 0px' }}
        />
      </CardActionArea>
      {/* <Chip className={classes.chip} label={trending.restaurantId.name} /> */}
      <div className={classes.overlay}></div>
    </Card>
  )
}

export default TrendingCard
